import { isiOSDevice } from './common';

// TODO: review content
export const getRefundCreditText = (success: boolean) => {
    if (success) return 'Refund has been credited to';
    return 'You will receive refund shortly in';
};

export const scrollLastMessageIntoView = () => {
    const messagesList = document.querySelectorAll('.message');
    const { length } = messagesList;
    if (length) {
        messagesList[length - 1].scrollIntoView();
    }
};

export const getFileType = (fileType: File['type']) => {
    if (fileType.includes('image')) return 'image';
    if (fileType.includes('pdf')) return 'pdf';
    return 'any';
};

export const taraStatus = {
    disable: () => localStorage.setItem('tara-enabled', 'false'),
    enable: () => localStorage.setItem('tara-enabled', 'true'),
    isEnabled: () => !isiOSDevice() && localStorage.getItem('tara-enabled') === 'true',
    nudge: () => localStorage.setItem('tara-nudged', 'true'),
    isNudged: () => isiOSDevice() || localStorage.getItem('tara-nudged') === 'true',
    introduce: () => localStorage.setItem('tara-introduced', 'true'),
    isIntroduced: () => isiOSDevice() || localStorage.getItem('tara-introduced') === 'true',
};
